import { usePermissions } from 'hooks/usePermissions';
import { useRecordModal } from 'hooks/useRecordModal';
import { MerchantsArchiveDialog } from 'pages/Merchants/components/MerchantsArchiveDialog/MerchantsArchiveDialog';
import { useEditController } from 'react-admin';
import { CancelButton, SaveButton, DeleteButton } from 'shared/mui/Buttons';
import { EditGuesserPage } from 'shared/react-admin/Pages/EditGuesserPage/EditGuesserPage';
import { Merchant } from 'types/embedded/merchant';
import { Permission } from 'types/embedded/permission';

import { MerchantsEditForm } from './MerchantsEditForm';

export const MerchantsEdit: React.FC = () => {
  const { record } = useEditController();
  const { hasResourcePermissions } = usePermissions();

  const { handleCloseRecordModal, openRecordModal, handleOpenRecordModal } =
    useRecordModal<Merchant>();

  return (
    <EditGuesserPage
      leftActionsSlot={
        hasResourcePermissions('merchants', [Permission.Full, Permission.Delete]) ? (
          <DeleteButton
            label="Архивировать"
            onClick={() => handleOpenRecordModal()}
            variant="outlined"
          />
        ) : undefined
      }
      listName="Мерчанты"
      mutationOptions={{
        onError: () => undefined,
      }}
      rightActionsSlot={[
        <CancelButton key="cancel-button" linkType="back" variant="outlined" />,
        <SaveButton key="save-button" label="Сохранить" />,
      ]}
      title="Редактирование мерчанта"
    >
      {openRecordModal && (
        <MerchantsArchiveDialog
          onClose={handleCloseRecordModal}
          open={openRecordModal}
          record={record}
        >
          <CancelButton
            label="Вернуться к списку мерчантов"
            linkType="back"
            sx={{ marginLeft: 'auto' }}
            variant="outlined"
          />
        </MerchantsArchiveDialog>
      )}
      <MerchantsEditForm />
    </EditGuesserPage>
  );
};
